export default "__VITE_ASSET__05LMXXLT__"